import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import store from './config/store';
import { Provider } from 'react-redux';
import Routes from './Routes';
import ProgressAlerts from './components/notification/ProgressAlerts';
import ScrollToTop from './utils/ScrollToTop';
import CssBaseline from '@material-ui/core/CssBaseline';
import { highchartBaseConfig } from 'config/appConfig';
import Highcharts from 'highcharts';
import wrapWithErrorBoundary from 'global/ErrorBoundary';
import MaintenancePage from 'components/MaintenancePage/MaintenancePage';
import { ClimbingLoader } from './global/Spinners';
import { checkIsSiteUnderMaintenanc } from 'global/GlobalActions';
import './app.css';

// set font-family for highchart everywhere
Highcharts.setOptions(highchartBaseConfig);

const App = () => {
  const [isSiteUnderMaintenance, setIsSiteUnderMaintenance] = useState(false);

  useEffect(() => {
    (async () => {
      setIsSiteUnderMaintenance(await checkIsSiteUnderMaintenanc());
    })();
  }, []);

  const getComponent = () => {
    switch (isSiteUnderMaintenance) {
      case true:
        return <MaintenancePage />;
      case false:
        return wrapWithErrorBoundary(
          <Provider store={store}>
            <BrowserRouter basename="/">
              <ScrollToTop>
                <ProgressAlerts />
                <Routes />
              </ScrollToTop>
            </BrowserRouter>
          </Provider>,
          'primary'
        );
      default:
        return <ClimbingLoader />;
    }
  };
  return (
    <>
      <CssBaseline />
      {getComponent()}
    </>
  );
};

export default App;
